import { render, staticRenderFns } from "./MiniVip.vue?vue&type=template&id=0678038e&"
import script from "./MiniVip.vue?vue&type=script&lang=js&"
export * from "./MiniVip.vue?vue&type=script&lang=js&"
import style0 from "./MiniVip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports